import { createRouter } from '@blocks/base/router';

export default createRouter({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      component: () => import('../views/Index'),
      meta: {
        level: 2,
      },
    },
    {
      path: '/share',
      component: () => import('../views/Share'),
    },
    {
      path: '/my',
      component: () => import('../views/My'),
    },
    {
      path: '/rule',
      component: () => import('../views/Rule'),
      meta: {
        level: 3,
      },
    },
    // 下面这段必须放在最后
    {
      path: '*',
      redirect: '/index',
    },
  ],
});

